














import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import CzMenu from "../menu/czmenu.vue";
import Footer from "@/shared/components/footer/footer.vue";
import store from "@/shared/core/store";
import { applyBrandTheme } from "@/shared/core/helpers/brandHelper";

@Component({
  components: {
    CzMenu,
    Footer,
  },
})
export default class InSecure extends Vue {
  mounted() {
    applyBrandTheme(store.state.settings);
  }
}
